import { useAuth } from '@/lib'
import ctl from '@netlify/classnames-template-literals'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ProvidedMainNavConfigContext } from '../../core/main-nav-context'
import { Glyphs, Jobibot } from '../../rapid-ui'

type EmptyStateProps = {
	userFirstName: string
}

export function EmptyState({ userFirstName }: EmptyStateProps) {
	const { t } = useTranslation()
	const { can } = useAuth()
	const canCreateCampaign = can('campaign:create')
	const { newCampaignLinker } = useContext(ProvidedMainNavConfigContext)

	return (
		<div
			className={ctl(`
				flex items-center justify-center 
				h-[var(--screen-height)]
			`)}
		>
			<div
				className={ctl(`
					bg-white rounded-3xl shadow-lg
					px-12 py-10
					max-w-[500px]
					relative
				`)}
			>
				{/* Jobibot logo in top left */}
				<div className="absolute top-[0px] left-[-50px]">
					<Jobibot size={34} />
				</div>

				{/* Main content */}
				<div className="mt-1">
					<h1 className="text-3xl font-bold text-grey-900 mb-4">
						{canCreateCampaign
							? t('dashboard.emptyState.title', { name: userFirstName })
							: t('dashboard.emptyState.noAccessTitle', { name: userFirstName })}
					</h1>
					<p className="text-base text-grey-600 mb-8">
						{canCreateCampaign
							? t('dashboard.emptyState.description')
							: t('dashboard.emptyState.noAccessDescription')}
					</p>

					{/* Button */}
					{canCreateCampaign && newCampaignLinker({
						children: (
							<span
								className={ctl(`
									inline-flex gap-2 items-center
									px-6 py-3 bg-gradient-to-br from-indigo-700 via-indigo-600 via-40% to-brand-600
									z-10 shadow-brand-500/30
									text-white text-lg rounded-lg
									transition-colors
									font-medium
								`)}
							>
								<div className="size-[14px]">
									<Glyphs.core.PlusIcon />
								</div>
								{t('dashboard.emptyState.createCampaign')}
							</span>
						),
					})}
				</div>
			</div>
		</div>
	)
}
